import React from 'react';
import Modal from 'react-bootstrap/lib/Modal';
import {connect} from 'react-redux';
import Button from 'react-bootstrap/lib/Button';
import * as actions from '../../../actions/response';
import {converter} from '../../../helpers/converter';
import { GetRegion } from '../../../constants';

class ModalSocialLevelUp extends React.Component {

  constructor(props) {
    super(props);
    this.closeModal = this.closeModal.bind(this);
  }

  closeModal() {
    this.props.closeModal('SocialLevelUp');
  }

  render() {
    const apaLevelInfo = (JSON.parse(this.props.metadata.social_levels))[GetRegion()] || (JSON.parse(this.props.metadata.social_levels))['default'];
    const new_level_info = apaLevelInfo[`level${this.props.newLevelNumber}`] || apaLevelInfo['default'];
    const next_level_info = apaLevelInfo[`level${this.props.nextLevelNumber}`] || apaLevelInfo['default'];
    const congrats_text = converter.convertApaUnicode(this.props.translations, 'sc_congratulations', '¡Felicidades!');
    const new_level_number = (new_level_info.level_name == 'sc_default_level') ? '' : `${converter.convertApaUnicode(this.props.translations, '', 'Nivel')} ${this.props.newLevelNumber}`;
    const new_level_name_text = this.props.translations[new_level_info.level_name];
    const next_level_name_text = `${(next_level_info.level_name == 'sc_default_level') ? '' : 'Próximo nivel: ' }${this.props.translations[next_level_info.level_name]}`;
    const aceptButtonText = converter.convertApaUnicode(this.props.translations, 'modal_cancel_success_ok', 'Aceptar');
    //Si ambos textos son iguales quiere decir que ninguno de los dos está definido lo que significa que se alcanzó el máximo nivel definido
    //En este caso no se debe mostrar el texto del siguiente nivel
    const showNextLevelText = (new_level_name_text != next_level_name_text);
    return (
      <Modal show={true} id='modalSocialLevelUp'>
        <Modal.Header>
          <Button className='close close-modal' onClick={this.closeModal}>x</Button>
        </Modal.Header>
        <Modal.Body className='text-center success'>
          <p className='padding-top-2'>
            <img className='level-up-img' src={this.props.apaAssets[new_level_info.level_asset]} />
          </p>
          <div className='congrats-text-div'>{ congrats_text }</div>
          <div className='level-text-div'>{ new_level_number }</div>
          <div className='level-name-text-div' >{ new_level_name_text }</div>
          { showNextLevelText && <div className='next-level-name-text-div'>{ next_level_name_text }</div> }
        </Modal.Body>
        <Modal.Footer>
          <div className='row'>
            <div className='level-up-modal-footer-div'>
              <Button className='level-up-modal-btn' bsSize='large' onClick={this.closeModal}>{ aceptButtonText }</Button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>
    )
  }
}

const mapStateToProps = state => {
  return {
    metadata: state.metadata,
    translations: state.translations,
    apaAssets: state.asset,
    user: state.user,
  };
};

const mapDispatchToProps = (dispatch) => ({
  closeModal(modalType) {
    dispatch(actions.removeModal(modalType));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(ModalSocialLevelUp);
